<template>
  <div>
    <el-row class="planListbox" v-for="(plan, index) in dataList" :key="index">
      <el-col :span="10" class="imgW"><img :src="plan.imgUrl" :onerror="defaultImg"/></el-col>
      <el-col :span="14" class="p10">
        <el-col class="planListTitle">{{plan.title}}</el-col>
        <el-col class="planListCon">
          {{plan.content}}
        </el-col>
        <!--<el-col>-->
          <!--<router-link :to="{name:'contentPhone', query:{id:plan.childId}}">-->
            <!--<el-button>查看详细服务</el-button>-->
          <!--</router-link>-->
        <!--</el-col>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dataSource from '@/data/service'
export default {
  name: 'listmb',
  imhh: '',
  data () {
    return {
      dataSource,
      dataList: [],
      defaultImg: require('@/assets/img/zwtp.png')
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    }
  },
  watch: {
    title (newVal) {
      this.dataList = dataSource[this.title]
      // console.log('dataList', this.dataList)
    }
  },
  created () {
    this.dataList = dataSource[this.title]
    // console.log('dataList', this.dataList)
  }
  // methods: {
  //   imgload() {
  //     this.$nextTick(function(){
  //       setTimeout(() => {
  //         let imgh = this.$refs['imghh'].offsetHeight;
  //         this.imhh = imgh + 'px';
  //         alert(imgh)
  //       }, 2000)
  //     })
  //   }
  // },
  // mounted(){
  //   this.$nextTick(() => {
  //     this.imgload();
  //   })
  // }
}
</script>

<style scoped>
  .planListbox {
    margin-top: 30px;
    margin-bottom: 30px;
    background: #f7f7f7
  }

  .planListTitle {
    font-size: 20px;
    margin: 25px 0px 20px 0px;
  }

  .planListCon {
    font-size: 14px;
    line-height: 25px;
    color: #999;
  }

  @media (min-width: 100px) {
    .imgW img {
      width: 100%
    }

    .planListTitle {
      font-size: 20px;
      margin: 7px 0px 7px 0px;
    }

    .p10 {
      padding-left: 10px;
      padding-right: 10px;
    }
    .el-button--medium {
      padding: 8px 15px;
      font-size: 14px;
      border-radius: 30px;
      margin: 10px 20px 0px 20px;
      background: #3195c5;
      color: #fff;
    }
  }
</style>
